import runContext from "./RunContext";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import qs from 'qs' 


const RunContextProvider = (props) => {
  // clients
  const [clients, SetClients] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const [outputValue, setOutputValue] = useState("");
  async function handleRun(code, language) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/run`,
        {
          code: code,
          language: language,
        }
      );
      setOutputValue(response.data.output);
      toast.success("Compiled Successfully");
    } catch (error) {
      toast.error("Compilation Failed");
      setOutputValue(error.error);
    }
  }
  // crete file
  async function createFile(filename, inputValue, roomId,language) {
    try {
      const response = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_BACKEND_URL}/api/files`,
        headers: {
          "Content-Type": "application/json",
          authtoken: localStorage.getItem("authtoken"),
        },
        data: JSON.stringify({
          filename,
          data: inputValue,
          roomId,
          language,
          username: localStorage.getItem("username"),
        }),
      });
      return response.data;
    } catch (err) {
      return false;
    }
  }


  // run using Codex-API 

  async function runWithCodexApi(language,data,input){
    const body = qs.stringify({
      code:data,
      language:language,
      input:input || null
    })
      try {
        const response = await axios({
          method: "POST",
          url: `https://api.codex.jaagrav.in`,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          data: body,
        });
        // console.log(response.data)
        if(response.data.error !== ""){
          toast.success("Compiled with errors");
          setOutputValue(response.data.error);
        }else{
          toast.success("Compiled Successfully");
          setOutputValue(response.data.output);
        }
      } catch (error) {
        toast.error("something went's wrong");
      }
  }
  return (
    <runContext.Provider
      value={{
        handleRun,
        outputValue,
        setOutputValue,
        clients,
        SetClients,
        inputValue,
        setInputValue,
        createFile,
        runWithCodexApi
      }}
    >
      {props.children}
    </runContext.Provider>
  );
};
export default RunContextProvider;
